<template>
  <div class="map" id="map"></div>
</template>

<script>
  import mapboxgl from "mapbox-gl";

  export default {
    name: 'Map',
    props: {},

    mounted(){
      mapboxgl.accessToken = 'pk.eyJ1IjoiYmVuZGF3c29uIiwiYSI6ImNrZ3oxcnh3cjBqMzEydHF2MXV4ZXA3aWoifQ.rnt1Wq6u6BqIyNPNoivTkA';   
      var map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/light-v10',
        center: [11.255, 43.7699],
        zoom: 18,
        attributionControl: false        
      });                
    
      const customMarker = document.createElement('div');
      const circleIcon = document.createElement('div');
      customMarker.className = 'custom-marker';
      circleIcon.className = 'circle';
      customMarker.appendChild(circleIcon);        

      let marker = new mapboxgl.Marker(customMarker).setLngLat([11.255, 43.7699]).addTo(map);   
    },
    methods: {
     
    }
  }
</script>

<style src='mapbox-gl/dist/mapbox-gl.css'></style>
<style lang="scss">
  @import "../styles/_colors.scss";
  @import "../styles/_mixins.scss";

  .map{min-height: 400px; max-height: 67vh; height: calc(100vh - 244px);
    .mapboxgl-ctrl-bottom-left{display: none;}
    .custom-marker{width: 66px; height: 56px; display: flex; align-items: center; justify-content: center; background-color: $black; position: relative;
      .circle{width: 24px; height: 24px; display: flex; background-color: $gold; border-radius: 100%;}
      &:after{content:""; position: absolute; width: 0; height: 0; border-left: 12px solid transparent; border-right: 12px solid transparent; border-top: 30px solid $black; bottom: -30px;}
    }   
  }

</style>
